import { useEffect, useState } from "react";

// @mui material components
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import MenuItem from "@mui/material/MenuItem";

// Material Dashboard 2 PRO React TS components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";

// Material Dashboard 2 PRO React TS examples components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";

import DashboardNavbar from "examples/Navbars/DashboardNavbar";
// Data
import { MemberService } from "service/member/service";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
  ListItemText,
  Modal,
  OutlinedInput,
  Pagination,
  Radio,
  RadioGroup,
  Select,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import MDInput from "components/MDInput";
import { info } from "./data/dummyPromotionData";
import DataTable from "examples/Tables/DataTable";
import { text } from "stream/consumers";
import { PromotionService } from "service/promotion/service";

const getTodayDate = (daysOffset = 0) => {
  const today = new Date();
  today.setDate(today.getDate() + daysOffset);
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, "0");
  const dd = String(today.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};

function Promotion(): JSX.Element {
  const limit = 10;
  const [tableData, setTableData] = useState<any[]>([]);

  const [sortType, setSortType] = useState("AD");
  const [promotionType, setPromotionType] = useState("A");
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [startDate, setStartDate] = useState("2025-01-01");
  const [endDate, setEndDate] = useState(getTodayDate());
  const [search, setSearch] = useState("");
  const [recommendCode, setRecommendCode] = useState("");
  const [promotionNames, setPromotionNames] = useState<any[]>([]);
  const [recommendCodes, setRecommendCodes] = useState<any[]>([]);

  const list = async (
    promotionType: string,
    sortType: string,
    search: string,
    recommendCode: string,
    startDate: string,
    endDate: string,
    limit: number,
    page: number
  ) => {
    try {
      const promoCode = promotionType === "A" ? "" : promotionType;

      const res = await PromotionService.list(
        promoCode,
        sortType,
        search,
        recommendCode,
        startDate,
        endDate,
        limit,
        page
      );

      setTableData(res.list);
      setTotalPages(Math.ceil(res.totalCount / limit));
    } catch (err) {
      console.log(err);
    }
  };

  const csv = async () => {
    try {
      const promoCode = promotionType === "A" ? "" : promotionType;
      const a = document.createElement("a");
      a.href = `${process.env.REACT_APP_HOST}admin/csv4?startDate=${startDate}&endDate=${endDate}&promoCode=${promoCode}&search=${search}&sort=${sortType}&recommendCode=${recommendCode}`;
      a.download = "";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (err) {
      console.log(err);
    }
  };

  const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setCurrentPage(value);
  };

  useEffect(() => {
    setCurrentPage(1);
    list(promotionType, sortType, search, recommendCode, startDate, endDate, limit, currentPage);
  }, [promotionType, startDate, endDate, sortType, recommendCode]);

  useEffect(() => {
    list(promotionType, sortType, search, recommendCode, startDate, endDate, limit, currentPage);
  }, [currentPage]);

  useEffect(() => {
    (async () => {
      const list = await MemberService.recommendCodeList();
      setRecommendCodes(list);
      const promotions = await PromotionService.promotionNames();
      setPromotionNames(promotions);
    })();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox my={3}>
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "end",
            gap: "16px",
            padding: "0 8px",
          }}
        >
          <div
            style={{
              padding: "8px",
              borderRadius: "8px",
              backgroundColor: "white",
              display: "flex",
              gap: "8px",
              alignItems: "center",
              fontSize: "14px",
              fontWeight: 500,
              border: "1px solid black",
              cursor: "pointer",
            }}
            onClick={csv}
            role="button"
          >
            <Icon>description</Icon>
            CSV 다운로드
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "8px",
            }}
          >
            <div
              style={{
                display: "flex",
                gap: "4px",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <span
                style={{
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#344676",
                  fontFamily: "Pretendard",
                }}
              >
                검색어
              </span>
              <input
                type="text"
                placeholder="성명, 이메일, 연락처"
                style={{ padding: "8px" }}
                onChange={(e: any) => setSearch(e.target.value)}
              />
              <div
                style={{
                  padding: "8px",
                  backgroundColor: "rgb(30, 155, 107)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "13px",
                  fontWeight: 600,
                  color: "white",
                  borderRadius: "8px",
                  width: "50px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  setCurrentPage(1);
                  list(
                    promotionType,
                    sortType,
                    search,
                    recommendCode,
                    startDate,
                    endDate,
                    limit,
                    currentPage
                  );
                  // list(promotionType, search, startDate, endDate, limit, 0);
                }}
              >
                검색
              </div>
            </div>
            <div
              style={{
                display: "flex",
                gap: "4px",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <span
                style={{
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#344676",
                  fontFamily: "Pretendard",
                }}
              >
                프로모션명
              </span>
              <select
                // value={promotionType}
                style={{ padding: "8px" }}
                onChange={(e: any) => setPromotionType(e.target.value)}
              >
                <option value="">전체</option>
                {promotionNames.map((el, index) => (
                  <option value={el.promo_code} key={index}>
                    {el.val}
                  </option>
                ))}
              </select>
            </div>
            <div
              style={{
                display: "flex",
                gap: "4px",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <span
                style={{
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#344676",
                  fontFamily: "Pretendard",
                }}
              >
                추천인 코드
              </span>
              <select
                // value={promotionType}
                style={{ padding: "8px" }}
                onChange={(e: any) => setRecommendCode(e.target.value)}
              >
                <option value="">전체</option>
                {recommendCodes.map((el: any, index: number) => (
                  <option value={el.code} key={index}>
                    {el.label}
                  </option>
                ))}
              </select>
            </div>
            <div
              style={{
                display: "flex",
                gap: "4px",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <span
                style={{
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#344676",
                  fontFamily: "Pretendard",
                }}
              >
                정렬 기준
              </span>
              <select
                name=""
                id=""
                style={{ padding: "8px" }}
                onChange={(e: any) => setSortType(e.target.value)}
              >
                {sortData.map((el, index) => (
                  <option value={el.value} key={index}>
                    {el.label}
                  </option>
                ))}
              </select>
            </div>
            <div style={{ gap: "16px", display: "flex" }}>
              <div
                style={{
                  display: "flex",
                  gap: "4px",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <span
                  style={{
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#344676",
                    fontFamily: "Pretendard",
                  }}
                >
                  시작일 선택
                </span>
                <input
                  type="date"
                  value={startDate}
                  style={{ padding: "8px" }}
                  onChange={(e: any) => setStartDate(e.target.value)}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  gap: "4px",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <span
                  style={{
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#344676",
                    fontFamily: "Pretendard",
                  }}
                >
                  종료일 선택
                </span>
                <input
                  type="date"
                  value={endDate}
                  style={{ padding: "8px" }}
                  onChange={(e: any) => setEndDate(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>
        <Card style={{ marginTop: "24px" }}>
          <div style={{ padding: "24px 16px" }}>
            <div style={{ overflowX: "auto" }}>
              <table style={{ minWidth: "1000px", width: "100%" }}>
                <thead>
                  <tr
                    style={{
                      fontSize: "14px",
                      width: "100%",
                      textAlign: "center",
                      marginBottom: "16px",
                      fontFamily: "Pretendard",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <th>신청일자</th>
                    <th>프로모션명</th>
                    <th>이름</th>
                    <th>이메일</th>
                    <th>연락처</th>
                    <th>회원가입일자</th>
                    <th>최근방문일자</th>
                    <th>신청 자격</th>
                  </tr>
                </thead>
                <tbody>
                  {tableData.map((el: any, idx) => (
                    <tr
                      key={idx}
                      style={{
                        fontSize: 12,
                        color: "#000000DE",
                        textAlign: "center",
                        fontFamily: "Pretendard",
                      }}
                    >
                      <td
                        style={{
                          borderBottom: "1px solid #0000001A",
                          padding: "16px 8px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {el.create_time}
                      </td>
                      <td
                        style={{
                          borderBottom: "1px solid #0000001A",
                          padding: "16px 8px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {el.description}
                      </td>
                      <td
                        style={{
                          borderBottom: "1px solid #0000001A",
                          padding: "16px 8px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {el.name}
                      </td>
                      <td
                        style={{
                          borderBottom: "1px solid #0000001A",
                          padding: "16px 8px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {el.email}
                      </td>
                      <td
                        style={{
                          borderBottom: "1px solid #0000001A",
                          padding: "16px 8px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {el.tel && el.tel.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3")}
                      </td>
                      <td
                        style={{
                          borderBottom: "1px solid #0000001A",
                          padding: "16px 8px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {el.regdate}
                      </td>
                      <td
                        style={{
                          borderBottom: "1px solid #0000001A",
                          padding: "16px 8px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {(el?.last_login && el.last_login.split("T")[0]) || "-"}
                      </td>
                      <td
                        style={{
                          borderBottom: "1px solid #0000001A",
                          padding: "16px 8px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        <a
                          href={el.info}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: "#1976d2", textDecoration: "underline" }}
                        >
                          {el.info}
                        </a>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div style={{ display: "flex", justifyContent: "center", marginTop: "24px" }}>
              <Pagination
                count={totalPages}
                page={currentPage}
                onChange={handlePageChange}
                color="secondary"
                sx={{
                  "& .MuiPaginationItem-root": {
                    "&.Mui-selected": {
                      backgroundColor: "#1e9b6b",
                      color: "white",
                    },
                    "&.Mui-selected:hover": {
                      backgroundColor: "#1e9b6b",
                    },
                  },
                }}
              />
            </div>
          </div>
        </Card>
      </MDBox>
    </DashboardLayout>
  );
}
export default Promotion;

const sortData = [
  { label: "신청일 최신순", value: "AD" },
  { label: "신청일 오래된순", value: "AA" },
];

const promotionData = [
  { value: "A", label: "전체" },
  { value: "신규 0원(스탠다드)", label: "신규 0원(스탠다드)" },
  { value: "신규회원 무료체험", label: "신규회원 무료체험" },
  { value: "얼리버드", label: "얼리버드(50%)" },
  { value: "기존 트랜스파머 회원", label: "기존 트랜스파머 회원" },
  { value: "대표님 지인", label: "대표님 지인" },
];
